import { Route, Switch, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

// all pages imported
import NavBar from "./Components/NavBar";
import Homepage from "./Components/Homepage";
import Swap from "./Components/Swap";
import Userticket from "./Components/Userticket";
import BookEvent from "./Components/BookEvent";
import Loader from "./Utils/loader.gif";
 
//Contexts
import UserContext from "./Contexts/UserContext";

//toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { toast } from "react-toastify";

//Web3 library
import Web3 from "web3";

//import Abis
import SwapAbi from "./contracts/Swap.json";
import TokenAbi from "./contracts/Token.json";
import EventRegistrationAbi from "./contracts/EventRegistration.json";

export default function App() {
  let location = useLocation();
  const [currentAccount, setCurrentAccount] = useState(null);
  const [networkId, setNetWorkId] = useState(null);

  // smart contracts
  const [token, setToken] = useState(null);
  const [swap, setSwap] = useState(null);
  const [event, setEvent] = useState(null);

  // wallet balance
  const [tokenBalance, setTokenBalance] = useState("");
  const [ethBalance, setEthBalance] = useState("");
  const [swapAddress, setSwapAddress] = useState(null);

  // data related to event for a registrant
  const [amountPaid, setAmountPaid] = useState(null);
  const [numOfTicketBookedByUser, setNumOfTicketBookedByUser] = useState(0);
  const [priceOfTicket, setPriceOfTicket] = useState("");
  const [quota, setQuota] = useState(null);
  const [numOfTicketsBooked, setNumOfTicketsBooked] = useState(null);
  const [numOfTicketSold, setNumOfTicketSold] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadWeb3();
  }, [priceOfTicket, quota, numOfTicketsBooked, numOfTicketSold, amountPaid]);

  const loadWeb3 = async () => {
    setIsLoading(true);
    if (window.ethereum) {
      await window.ethereum.enable();
    setIsLoading(false);
      loadBlockchainData();
    } else {
      toast("Please Connect To A Wallet. Try Using Metamask.", {
        type: "error",
        autoClose: 15000,
      });
    }
  };

  const loadBlockchainData = async () => {
    if (typeof window.ethereum === "undefined") {
      return;
    }
    setIsLoading(true);

    const web3 = new Web3(window.ethereum);

    var accounts = await web3.eth.getAccounts();
    setCurrentAccount(accounts[0]);

    const networkId = await web3.eth.net.getId();
    setNetWorkId(networkId);

    if (networkId !== 4) {
      toast("Use Rinkeby Test network", { type: "error", autoClose: 15000 });
      return;
    }

    var ethBalance = await web3.eth.getBalance(accounts[0]);
    setEthBalance(ethBalance);

    // Load Token
    const tokenData = TokenAbi.networks[networkId];
    if (tokenData) {
      const token = new web3.eth.Contract(TokenAbi.abi, tokenData.address);
      setToken(token);
      let tokenBalance = await token.methods.balanceOf(accounts[0]).call();
      setTokenBalance(tokenBalance.toString());
    } else {
      toast("Token contract not deployed to detected network.", {
        type: "error",
      });
    }

    // Load Swap
    const SwapData = SwapAbi.networks[networkId];
    if (SwapData) {
      const swap = new web3.eth.Contract(SwapAbi.abi, SwapData.address);
      setSwap(swap);
      setSwapAddress(SwapData.address)
    } else {
      toast("Swap contract not deployed to detected network.", {
        type: "error",
      });
    }

    // Load Event Registration
    const EventRegistrationData = EventRegistrationAbi.networks[networkId];
    if (EventRegistrationData) {
      const event = new web3.eth.Contract(
        EventRegistrationAbi.abi,
        EventRegistrationData.address
      );
      setEvent(event);
      const amountPaid = await event.methods.getRegistrantAmountPaid().call({from: accounts[0]});
      const numOfTicketBookedByUser = await event.methods.getRegistrantNumOfTickets().call({from: accounts[0]});
      const priceOfTicket = await event.methods.price().call();
      const quota = await event.methods.quota().call();
      const numOfTicketSold = await event.methods.numTicketSold().call();
      const numOfTicketsBooked = await event.methods
        .getRegistrantNumOfTickets()
        .call();
      setAmountPaid(amountPaid);
      setPriceOfTicket(priceOfTicket);
      setQuota(quota);
      setNumOfTicketSold(numOfTicketSold);
      setNumOfTicketsBooked(numOfTicketsBooked);
      setNumOfTicketBookedByUser(numOfTicketBookedByUser);
      console.log(amountPaid)
      console.log(numOfTicketBookedByUser)
    } else {
      toast("Event Registration contract not deployed to detected network.", {
        type: "error",
      });
    }
    setIsLoading(false);
  };

  //functions for swap contract
  const buyTokens = async (etherAmount) => {
    setIsLoading(true);
    await swap.methods
      .buyTokens()
      .send({ value: etherAmount, from: currentAccount })
      setIsLoading(false);
      toast("Hit Refresh",{type: "info"});
  };

  const sellTokens = async (tokenAmount) => {
    setIsLoading(true);
    await token.methods
      .approve(swapAddress, tokenAmount)
      .send({ from: currentAccount })
      .on("transactionHash", (hash) => {
        swap.methods
          .sellTokens(tokenAmount)
          .send({ from: currentAccount })
      });
      setIsLoading(false);
      toast("Hit Refresh",{type: "info"});
  };
  //functions for event booking
  const buyTicket = async (numOfTickets) => {
    setIsLoading(true);
     await event.methods
      .buyTicket(numOfTickets)
      .send({ value: numOfTickets * priceOfTicket, from: currentAccount })
    setIsLoading(false);
    toast("Hit Refresh",{type: "info"});
  };

  const cancelTicket = async () => {
    setIsLoading(true);
    await event.methods.refundTicket().send({ from: currentAccount });
    setIsLoading(false);
    toast("Hit Refresh",{type: "info"});
  };

  if (networkId !== 4)
    return (
      <h1 className="text-center mt-5">Please connect to Rinkeby Testnet...</h1>
    );

  if(isLoading){
    return (
      <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <img src={Loader} alt="Loading..."></img>
    </div>
    )
  } 

  return (
    <>
      <ToastContainer />
      <UserContext.Provider
        value={{
          currentAccount,
          ethBalance,
          tokenBalance,
          buyTokens,
          sellTokens,
          buyTicket,
          cancelTicket,
          quota,
          numOfTicketSold,
          priceOfTicket,
          numOfTicketBookedByUser,
          amountPaid
        }}
      >
        <NavBar address={currentAccount} />
        <Switch location={location} key={location.key}>
          <Route path="/" exact component={Homepage} />
          <Route path="/swap" exact component={Swap} />
          <Route path="/userticket" exact component={Userticket} />
          <Route path="/bookEvent" exact component={BookEvent} />
        </Switch>
      </UserContext.Provider>
    </>
  );
}
